import { forwardRef } from "react";
import type { LucideIcon, LucideProps } from "lucide-react";

/**
 * EyeCaptain's gift, as a drop-in for lucide's Gift.
 *
 * Welcome credits, referral rewards, promo links and gifted credits all wear
 * it. A lid that sits proud of the box, a ribbon set a touch left of centre
 * (the iris of the eye mark is too), and a bow of a knot and two plain loops: the same round caps and joins as the rest of the set (EcMark,
 * EcIcons), so it reads as ours and not as a stock symbol.
 *
 * It takes LucideProps and forwards the ref, so it can sit in any
 * `icon: LucideIcon` slot and take the same className, size and strokeWidth a
 * lucide icon would.
 */
export const EcGift = forwardRef<SVGSVGElement, LucideProps>(function EcGift(props, ref) {
  const { size = 24, strokeWidth = 2, color = "currentColor", absoluteStrokeWidth, ...rest } = props;
  const sw = absoluteStrokeWidth ? (Number(strokeWidth) * 24) / Number(size) : strokeWidth;
  return (
    <svg
      ref={ref}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={color}
      strokeWidth={sw}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      focusable="false"
      {...rest}
    >
      {/* lid and box */}
      <rect x="2.75" y="8.25" width="18.5" height="3.75" rx="1.25" />
      <path d="M4.5 12v7a2 2 0 0 0 2 2h11a2 2 0 0 0 2-2v-7" />
      {/* ribbon, a touch left of centre like the iris in the eye mark */}
      <path d="M10.5 12v9" />
      {/* bow: a knot and two loops */}
      <circle cx="10.5" cy="6.9" r="1.1" />
      <path d="M9.4 6.8C7.6 7 5.9 6.2 5.7 4.9 5.5 3.7 6.8 3.2 7.9 3.8 9 4.4 9.6 5.7 9.4 6.8Z" />
      <path d="M11.6 6.8C13.4 7 15.1 6.2 15.3 4.9 15.5 3.7 14.2 3.2 13.1 3.8 12 4.4 11.4 5.7 11.6 6.8Z" />
    </svg>
  );
}) as LucideIcon;
